import React, { useEffect } from "react";
import Routes from "./Routes";
import DemoGate from "./components/DemoGate";
import { TenantProvider, useTenant } from "./context/TenantContext";
import EnvironmentBanner from "./components/ui/EnvironmentBanner";
import { runAutoPurge } from "./services/dataRetentionStore";

/**
 * AutoPurgeSweep
 * ──────────────
 * Mounted inside TenantProvider so it has access to the resolved tenant.
 * Triggers the data retention sweep on app load. The sweep itself is rate-
 * limited to once per hour, so page navigations don't hammer the engine.
 *
 * In production this is a cron job, not a browser hook. The browser hook
 * exists in this UAT so testers can see the mechanism execute end-to-end
 * without standing up infrastructure.
 */
const AutoPurgeSweep = () => {
  const { tenantId } = useTenant();
  useEffect(() => {
    if (!tenantId) return;
    try {
      runAutoPurge(tenantId);
    } catch (_) { /* fail silent, purge is best-effort */ }
  }, [tenantId]);
  return null;
};

function App() {
  return (
    <DemoGate><TenantProvider>
      <EnvironmentBanner />
      <AutoPurgeSweep />
      <Routes />
    </TenantProvider></DemoGate>
  );
}

export default App;
